/* global Swiper */
import '../../../javascripts/item_image_carousel';
import '../../../javascripts/items';
import '../../../javascripts/form_validation';
import '../../../javascripts/sanitize_item_text_field';
import '../../../javascripts/count_text';
import '../../../javascripts/swiper_carousel';
import '../../../javascripts/sign_up';
import '../../../javascripts/direct_upload';
import '../../../javascripts/item_new_cashed_images_handler';
import '../../../javascripts/photo_example_modal';
import '../../../javascripts/accordion';
import '../../../javascripts/mobile_header';
import '../../../javascripts/common/common_header_mega';
import Rails from 'rails-ujs';

window.addEventListener('load', () => {
  const buttonDisplayReviewListForPros = Rails.$('.button_display_review_list_for_pro');
  if (buttonDisplayReviewListForPros.length == 0) {
    return;
  }

  const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);
  if (isIOS) {
    const popupIframeContainer = Rails.$('.popup_iframe_container')[0];
    popupIframeContainer.style.overflowY = "scroll";
  }

  buttonDisplayReviewListForPros.forEach((element) => {
    element.addEventListener('click', () => {
      const reviewListIFrame = Rails.$('#review_list_for_pro')[0];
      reviewListIFrame.src = `/pix/users/${element.id}/pro/reviews?type=simple`;
    });
  });
});

window.addEventListener('load', () => {
  const swiperContainer = Rails.$('.completed_items');
  if (swiperContainer.length != 0 && typeof (Swiper) != "undefined") {
    // eslint-disable-next-line no-unused-vars
    const mySwiper = new Swiper('.completed_items', {
      loop: true,
      pagination: {
        el: '.swiper-items-pagination',
        clickable: true,
      },
    });
  }
});

window.addEventListener('load', () => {
  const swiperContainer = Rails.$('.swiper-review-container');
  const swiperSlides = Rails.$('.swiper-review-container .swiper-slide');
  if (swiperContainer.length != 0 && swiperSlides.length > 1) {
    // eslint-disable-next-line no-unused-vars
    const mySwiper = new Swiper('.swiper-review-container', {
      centeredSlides: true,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-review-pagination',
        clickable: true,
      },
      loop: true
    });
  }
});

window.addEventListener('load', () => {
  Rails.$('.more').forEach((more_button) => {
    more_button.addEventListener('click', function (e) {
      e.preventDefault();
      const tottleField = this.previousElementSibling.getElementsByClassName('toggle')[0];
      if (tottleField.style.display == 'none') {
        tottleField.style.display = 'inline';
        this.textContent = '閉じる';
      } else {
        tottleField.style.display = 'none';
        this.textContent = 'もっと見る';

      }
    });
  });
});

jQuery(() => {
  const openModalBtn = jQuery(".open-cancel-modal");
  const cancelModal = jQuery(".cancel-modal");
  const closeBtn = cancelModal.find(".back span, .close");

  openModalBtn.click(() => {
    cancelModal.show();
  });

  closeBtn.click(() => {
    cancelModal.hide();
  });
});
